<template>
	<div :class="['layout layout-secondary', { bg: hasBackground }]">
		<div class="layout-secondary__header">
			<div class="container">
				<div class="row">
					<div
						class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1"
					>
						<div class="layout-secondary__header__inner">
							<img src="/icons/128.png" class="logo img-fluid" />
							<div class="breadcrumbs">
								<router-link to="/">
									<h3>Dashboard</h3>
								</router-link>
								<h3 class="divider">/</h3>
								<h3>
									{{ this.$route.name }}
								</h3>
							</div>
							<router-link class="layout-secondary__close" to="/">
								<x-icon size="1.25x" class="custom-class"></x-icon>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="main">
			<slot></slot>
		</div>
	</div>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
export default {
	components: {
		XIcon,
	},
	computed: {
		hasBackground: function () {
			return this.$store.getters['settings/hasBackground'];
		},
	},
};
</script>

<style lang="scss">
.layout-secondary {
	position: relative;
	min-height: 100vh;
	height: auto;
	background-color: var(--g4);

	&.bg {
		background-color: rgb(6 6 6 / 85%);
	}

	&__header {
		&__inner {
			display: flex;
			align-items: center;
			padding: 0.5rem 0;
			margin-bottom: 1rem;
			border-bottom: rgba(255, 255, 255, 0.1) solid 1px;

			> img {
				max-width: 64px;
				height: auto;
			}

			h3 {
				margin-bottom: 0;
			}
			a {
				color: var(--p1);

				&:hover,
				&:active,
				&:focus {
					color: var(--p3);
					text-decoration: none;
				}
			}
		}
	}
	.breadcrumbs {
		margin-left: 1rem;
		display: flex;
		align-items: baseline;
	}
	.divider {
		font-weight: 300;
		margin: 0 0.5rem;
	}
	&__close {
		position: absolute;
		top: 24px;
		right: 8px;
		width: 32px;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
		transition: all 100ms linear;
		border-radius: 50%;
		cursor: pointer;
		color: var(--p1);
		background-color: rgba(255, 255, 255, 0.1);

		&:hover,
		&:active {
			color: var(--p5) !important;
			background-color: rgba(255, 255, 255, 0.3);
		}
	}
}
</style>
